export default {
  home: '/apps/home',
  adminTools: '/apps/home/#/admin',
  switchProfile: '/Platform/profile/select',
  signOut: '/Platform/logout',
  billingSummary:'/apps/billing/#/landing/summary',
  billingPayment: '/apps/billing/#/landing/payment'
};
